import { doSubscribeAjax, isFormValid } from "./util";

/**
 * Homepage Subscribe Block
 *
 * On sign up button click, it goes to the /newsletters page with prefilled values.
 */
function Block() {
	this.blocks = $(".wp-block-ess-newsletter-signup");

	this.init = function () {
		this.register();
	};

	this.register = () => {
		this.blocks.find(".subscribe-form").on("submit", this.submit);
	};

	this.submit = (e) => {
		const $form = $(e.target);

		if (!isFormValid($form, false)) {
			e.preventDefault();
			return;
		}
	};
}

export default new Block();
